'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getData();
  }

  getData() {
    this.$http.get('/api/peripherals').then(res => {
      this.data = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/peripherals/${id}`).then(res => {
        this.getData();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/peripheral/list/list.controller.js